import Communication from "@/components/communication/Communication";
import CommunicationLog from "@/components/communication/CommunicationLog";
import Activity from "@/components/Activity";
import MatchingLayout from "@/components/matching/Layout";
import MatchingIndex from "@/components/matching/Index";
import MatchingGroups from "@/components/matching/Groups";
import MatchingClasses from "@/components/matching/Classes";
import MatchingUsers from "@/components/matching/Users";
import Classroom from "@/components/classroom/Index";
import ClassroomLayout from "@/components/classroom/Layout";
import Class from "@/components/classroom/Class";
import Guardian from "@/components/guardian/Guardian";
import OrganisationSchools from "@/components/organisation/google/Schools";
import OrganisationSettings from "@/components/organisation/google/Settings";

export default [
	{
		path: "/matching",
		component: MatchingLayout,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		},
		children: [
			{
				name: "matching",
				path: "",
				component: MatchingIndex,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.groups",
				path: "/matching/groups",
				component: MatchingGroups,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.classes",
				path: "/matching/classes",
				component: MatchingClasses,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.users",
				path: "/matching/users",
				component: MatchingUsers,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			}
		]
	},
	{
		name: "activity",
		path: "/activity",
		component: Activity,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		}
	},
	{
		name: "communication",
		path: "/communication",
		component: Communication,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		}
	},
	{
		name: "communication.log",
		path: "/communication/log",
		component: CommunicationLog,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		}
	},
	{
		name: "guardian",
		path: "/guardian",
		component: Guardian,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		}
	},
	{
		name:"classrooms.layout",
		path: "/classrooms",
		component: ClassroomLayout,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: false
		},
		children: [
			{
				name: "classrooms",
				path: "/classrooms",
				component: Classroom,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: false
				},
				children: [
					{
						name: "classrooms.select",
						path: "/classrooms/:id",
						component: Class,
						meta: {
							requiresAuth: true,
							requiresShard: true,
							completedWizard: false
						}
					}
				]
			}
		]
	},
	{
		name: "organisation.schools",
		path: "/organisation/schools",
		component: OrganisationSchools,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: false
		}
	},
	{
		name: "organisation.settings",
		path: "/organisation/settings",
		component: OrganisationSettings,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: false,
			requiresEnterprise: true
		}
	},
];
